import { ProductVTO } from '../../../../pages/admin-dashboard/products/product.model';
import { ProductInfoInterface, Zone } from './product-info.model';

export function productInfoMapper(productInfo: ProductVTO, isArabic: boolean, zonesList: Zone[]): ProductInfoInterface {
  const matchedZone = zonesList.find((z: Zone) => z.id === productInfo.zone?.id);
  return {
    id: productInfo.id,
    titleAr: productInfo.titleAr,
    titleEn: productInfo.titleEn,
    descriptionAr: productInfo.descriptionAr,
    descriptionEn: productInfo.descriptionEn,
    categoryId: productInfo.category?.id,
    categoryTitle: isArabic ? productInfo.category?.titleAr : productInfo.category?.titleEn,
    availableQuantity: productInfo.availableQuantity,
    barcode: productInfo.barcode,
    batchNumber: productInfo.batchNumber,
    businessPrice: productInfo.businessPrice,
    businessPriceDiscountPercentage: productInfo.businessPriceDiscountPercentage,
    categoryProfileImageFid: productInfo.category?.profileImageFid,
    customerPrice: productInfo.customerPrice,
    expDate: productInfo.expDate,
    imagesFids: productInfo.imagesFids,
    isActive: productInfo.isActive,
    mfgCompanyId: productInfo.mfgCompany?.id,
    mfgCompanyTitle: isArabic ? productInfo.mfgCompany?.titleAr : productInfo.mfgCompany?.titleEn,
    mfgDate: productInfo.mfgDate,
    mfgProfileImageFid: productInfo.mfgCompany?.profileImageFid,
    profileImageFid: productInfo.profileImageFid,
    sellerPrice: productInfo.sellerPrice,
    sellerPriceDiscountPercentage: productInfo.sellerPriceDiscountPercentage,
    subCategoryId: productInfo.subCategory?.id,
    subCategoryProfileImageFid: productInfo.subCategory?.profileImageFid,
    subCategoryTitle: isArabic ? productInfo.subCategory?.titleAr : productInfo.subCategory?.titleEn,
    totalQuantity: productInfo.totalQuantity,

    zoneId: productInfo.zone?.id,
    zoneTitle: matchedZone ? (isArabic ? matchedZone.titleAr : matchedZone.titleEn) : undefined,
    isRefrigerated: productInfo.isRefrigerated ?? false,
  };
}
